// Libraries
import React, { useState } from 'react'
import PropTypes from 'prop-types'

// Components
import Media from 'ui/Media'

// Helpers
import { resolveErrorMessage } from 'helpers'

// Service
import message from 'services/message'

// Api
import { openGuideFile } from 'api/ticket-support'

// Model
import Category from 'models/Category'

// Use
import { useDesktop } from 'use/media'

function ListCategroyItem({ category }) {
  // User hook
  const isDesktop = useDesktop()

  // State
  const [isLoading, setLoading] = useState(false)

  const onClick = async (id) => {
    setLoading(true)

    try {
      await openGuideFile(id)
    } catch (error) {
      message.error(await resolveErrorMessage(error))
    } finally {
      setLoading(false)
    }
  }

  return (
    <Media
      round
      loading={isLoading}
      alignIcon="baseline"
      icon={
        category.iconUrl && (
          <img
            src={category.iconUrl}
            style={{ marginTop: isDesktop ? 10 : null }}
            width="70px"
          />
        )
      }
      title={category.title}
      description={category.description}
      onClick={() => onClick(category.id)}
    />
  )
}

ListCategroyItem.propTypes = {
  title: PropTypes.node,
  category: PropTypes.instanceOf(Category),
}

ListCategroyItem.defaultProps = {
  title: '',
  category: new Category(),
}

export default ListCategroyItem
